import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { value: "" }
const _hoisted_2 = ["value"]

import { computed, onMounted, ref, watch } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { ErrorBag } from '@/core/common';
import auth from '@/core/Auth';
import { getValueInUserLanguage } from '@/core/languageContent';
import { CustomerSubscription } from '@/modules/customer/CustomerSubscription';
import { ProductSubscription } from '@/modules/product/Product';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';
import AppInput from '@/core/components/form/AppInput.vue';

interface CustomerFormFirstSubscriptionProps {
	subscription: Partial<CustomerSubscription>;
	includeAddons?: boolean,
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormFirstSubscription',
  props: {
    subscription: {},
    includeAddons: { type: Boolean, default: false },
    errors: {}
  },
  emits: [
	'update:subscription',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const props = __props;
const emit = __emit;

const canSetPrice = auth.can('CUSTOMER_PRICE');
const data = ref<Partial<CustomerSubscription>>({});
const products = computed<ProductSubscription[]>(() => {
	let collection = store.getters.productSubscriptions;

	if (props.includeAddons) {
		collection = collection.concat(store.getters.productAddons);
	}

	return collection;
});
const productId = computed<number | string>({
	get() {
		return data.value.product?.id || '';
	},
	set(value: number | string) {
		data.value.product = {
			id: parseInt(value as string, 10),
		};
	},
});
let initialProductId = 0;

onMounted(async () => {
	data.value = Object.assign({}, props.subscription);
	initialProductId = data.value.product?.id ?? 0;
	await store.dispatch('loadProducts');
});

watch(() => data.value, (value) => {
	emit('update:subscription', value);
}, {
	deep: true,
});

watch(productId, () => {
	const product = products.value.find(p => p.id === parseInt(productId.value as string, 10));
	let price;

	if (product) {
		if (initialProductId === product.id) {
			return;
		}

		price = product.price;
	}

	data.value.price = price;
});

return (_ctx: any,_cache: any) => {
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppFormGroup, {
      id: "subscription_product",
      errors: __props.errors.product,
      label: _unref($gettext)('Abonnemang')
    }, {
      default: _withCtx(() => [
        _createVNode(AppSelect, {
          id: "subscription_product",
          modelValue: productId.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((productId).value = $event)),
          required: ""
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_1, [...(_cache[2] || (_cache[2] = [
              _createTextVNode("(Välj)", -1)
            ]))])), [
              [_directive_translate]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
              return (_openBlock(), _createElementBlock("option", {
                key: product.id,
                value: product.id
              }, _toDisplayString(_unref(getValueInUserLanguage)(product.content)), 9, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["errors", "label"]),
    (_unref(canSetPrice))
      ? (_openBlock(), _createBlock(AppFormGroup, {
          key: 0,
          id: "subscription_price",
          errors: __props.errors.price,
          label: _unref($gettext)('Pris (exkl. moms)')
        }, {
          default: _withCtx(() => [
            _createVNode(AppInput, {
              type: "number",
              id: "subscription_price",
              modelValue: data.value.price,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.value.price) = $event)),
              min: "0",
              step: "0.01",
              max: "9999999999999.99"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["errors", "label"]))
      : _createCommentVNode("", true)
  ]))
}
}

})